import React from 'react';
import { Svg } from '@marvelapp/ui';
export function MinusIcon(props) {
    return (React.createElement(Svg, Object.assign({ height: "30px", viewBox: "0 0 30 30", width: "30px" }, props),
        React.createElement("path", { d: "m19.8 13.8c.6627417 0 1.2.5372583 1.2 1.2s-.5372583 1.2-1.2 1.2h-9.6c-.6627417 0-1.2-.5372583-1.2-1.2s.5372583-1.2 1.2-1.2z" })));
}
